// Centralized keys for localStorage usage
export const LAST_PATIENT_ID_KEY = "lastPatientId";
export const COLOR_MODE_KEY = "colorMode";
export const TASK_PAGE_SIZE_KEY = "taskPageSize";
export const LOCALE_KEY = "locale";
export const pendingPatientEditKey = (id: string) => `pendingPatientEdit-${id}`;
export const pendingProgressNoteKey = (taskId: string) => `pendingProgressNote-${taskId}`;
export const pendingMessageKey = (subjectReference: string) => `pendingMessage-${subjectReference}`;
export const pendingMessageImageKey = (subjectReference: string) => `pendingMessageImage-${subjectReference}`;

// Non-PHI UI preferences kept across a storage wipe so they survive logout.
const PRESERVED_KEYS = [COLOR_MODE_KEY, LOCALE_KEY];

// Utility to clear all local and session storage, keeping the preserved UI preferences.
export function clearAllStorage(): void {
  const preserved = PRESERVED_KEYS.map(key => [key, localStorage.getItem(key)] as const);
  localStorage.clear();
  for (const [key, value] of preserved) {
    if (value !== null) {
      localStorage.setItem(key, value);
    }
  }
  sessionStorage.clear();
}

// Utility functions to set/get/remove pending* keys in sessionStorage instead of localStorage
export function setPendingItem(key: string, value: string): void {
  sessionStorage.setItem(key, value);
}
export function getPendingItem(key: string): string | null {
  return sessionStorage.getItem(key);
}
export function removePendingItem(key: string): void {
  sessionStorage.removeItem(key);
}
